import React, { useState, useEffect } from "react";
import "./CourseSyllabus.css";
import Popupboxx from "../Popupbox/Popupbox";
import AOS from "aos";
import "aos/dist/aos.css";

const modules = [
  {
    title: "Introduction to Automation Testing",
    points: [
      "Understanding the Need for Automation",
      "Benefits over manual testing",
      "Overview of various automation tools",
      "Introduction to Selenium and its components",
    ],
  },
  {
    title: "Core Java Fundamentals",
    points: [
      "Setting up the Java environment",
      "Basic programming concepts: variables, data types, operators",
      "Control structures and OOP principles",
      "Collections framework and File I/O",
    ],
  },
  {
    title: "Selenium IDE",
    points: [
      "Steps to install and configure Selenium IDE.",
      "How to record and playback automated tests using Selenium IDE.",
      "Introduction to the commands used in Selenium IDE.",
      "Creating and organizing test cases and test suites in Selenium IDE.",
      "Exporting Selenium IDE test cases to languages like Java, Python, etc.",
    ],

  },
  {
    title: "Selenium WebDriver: Architecture and Setup",
    points: [
      "Understanding the WebDriver architecture and setup process.",
      "Configuring browser drivers: Firefox, Chrome, IE, etc.",
      "Locating web elements using ID, Name, Class Name, Tag Name, Link Text, and Partial Link Text.",
      "Using XPath and CSS Selectors to find elements on the page.",
      "Handling various web elements like text boxes, buttons, checkboxes, and radio buttons.",
      "Working with dropdowns and select elements in Selenium WebDriver.",
      "Handling alerts, pop-ups, and frames in Selenium WebDriver.",
      "Working with web tables and handling dynamic data in tables.",
      "Performing mouse and keyboard actions in Selenium WebDriver.",
      "Capturing screenshots during test execution.",
      "Using implicit and explicit waits to handle synchronization issues in WebDriver.",
    ],

  },
  {
    title: "Introduction to TestNG",
    points: [
      "Setting up TestNG in Eclipse.",
      "Annotations in TestNG.",
      "Grouping and prioritizing tests in TestNG.",
      "Data-driven testing with parameters and DataProvider.",
      "Generating HTML reports in TestNG.",
      "Parallel test execution in TestNG.",
    ],

  },
  {
    title: "Introduction to Selenium Grid",
    points: [
      "Setting up the Hub and Nodes in Selenium Grid.",
      "Configuring tests for parallel execution in Selenium Grid.",
      "Running tests on multiple browsers and platforms using Selenium Grid.",

    ],

  },

  {
    title: "Framework Development",
    points: [
      "Designing a modular framework for efficient test automation.",
      "Data-driven framework implementation for testing with varying data sets.",
      "Understanding the basics of keyword-driven frameworks.",
      "Page Object Model (POM) design pattern for maintaining test automation code.",
      "Integrating frameworks with TestNG for efficient test management and execution."

    ],
  },

  {
    title: "Continuous Integration with Jenkins",
    points: [
      "Introduction to Jenkins and its role in Continuous Integration (CI).",
      "Setting up Jenkins for Selenium test automation.",
      "Creating and scheduling test jobs in Jenkins for continuous testing.",
      "Configuring email notifications for test job results in Jenkins.",

    ],
  },

  {
    title: "Version Control with Git",
    points: [
      "Introduction to Git and GitHub for version control and collaboration.",
      "Basic Git commands for managing your code repository.",
      "Integrating Git with Eclipse for version control in your development environment.",
      "Managing code versions and collaboration using Git and GitHub.",
      "Handling Dynamic Web Elements: Working with dynamic web elements in Selenium.",
      "Working with Headless Browsers: Introduction to working with headless browsers for faster test execution.",
      "Introduction to Behavior-Driven Development (BDD) with Cucumber: Understanding the concepts of Behavior-Driven Development (BDD) using Cucumber.",
      "Integrating Selenium with Other Tools like Maven: Integrating Selenium with tools like Maven for dependency management and build automation.",
    ],

  },
];

function CourseSyllabus() {
  const [activeModule, setActiveModule] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  // Detect screen size
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize(); // check on load
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

   useEffect(() => {
      AOS.init({ duration: 800, once: true });
    }, []);

  return (
    <>
    <section className="syllabus-section">
      <div className="container">
        <div className="headlines-for-all">
          <h4   data-aos="fade-up">
            <span>Course </span> Syllabus
          </h4>
          <p  data-aos="fade-up">
            Explore our comprehensive Automation Testing syllabus — built for
            real-world projects, hands-on learning, and 100% job readiness.
          </p>
        </div>


        {/* ---------- Desktop Tabs ---------- */}
        {!isMobile && (
          <>
            <div className="custom-btn-group "   data-aos="fade-up">
              {modules.map((m, index) => (
                <button
                  key={index}
                  className={`custom-btn ${activeModule === index ? "active" : ""
                    }`}
                  onClick={() => setActiveModule(index)}
                >
                  Module {index + 1}
                </button>
              ))}
            </div>

            <div className="custom-module-container"   data-aos="fade-up">
              <div className="custom-module-box active">
                <h4>{modules[activeModule].title}</h4>
                <ul className="ul-list-module">
                  {modules[activeModule].points.map((p, i) => (
                    <li key={i}>{p}</li>
                  ))}
                </ul>
              </div>
            </div>
          </>
        )}

        {/* ---------- Mobile Accordion (FAQ Style) ---------- */}
        {isMobile && (
          <div className="faq-container-course"   data-aos="fade-up">
            {modules.map((m, index) => (
              <div
                key={index}
                className={`faq-item-course ${activeModule === index ? "open" : ""
                  }`}
              >
                <button
                  className="faq-question-course"
                  onClick={() =>
                    setActiveModule(activeModule === index ? null : index)
                  }
                >
                  {m.title}
                  <span className="faq-icon-course">
                    {activeModule === index ? "−" : "+"}
                  </span>
                </button>

                <div
                  className="faq-answer-course"
                  style={{
                    maxHeight: activeModule === index ? "400px" : "0px",
                  }}
                >
                  <ul>
                    {m.points.map((p, i) => (
                      <li key={i}>{p}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="btn-center"   data-aos="fade-up">
          <button className="download-btn" onClick={() => setIsPopupOpen(true)}>Download Syllabus</button>
        </div>
      </div>
    </section>

  
       <Popupboxx
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
      />
      </>
  );
}

export default CourseSyllabus;
